/**
 * The per-message id on a "comment a word" DM link (`?dm=<ref>`, made by Lead Engine's
 * comment-replies/link-ref.ts). It lets Lead Engine follow ONE person from the DM to the page and
 * to the email they leave, so its funnel can count them and its one follow-up nudge knows not to
 * go to someone who already signed up.
 *
 * Same privacy rule as campaign-source.ts: nothing is written to the device. The ref lives in a
 * module variable for the life of the tab, and it says nothing about the person: it is 22 random
 * characters that only Lead Engine can look up.
 */

const REF = /^[A-Za-z0-9_-]{22}$/;

export function cleanDmRef(raw: unknown): string | null {
  return typeof raw === "string" && REF.test(raw) ? raw : null;
}

let current: string | null = null;

export function rememberDmRef(ref: string | null): void {
  if (ref) current = ref;
}

export function currentDmRef(): string | null {
  return current;
}
